import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

/** @deprecated No longer supported. May be replaced in future versions. */
export const Home1Icon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} data-testid={"home1-svg-icon"}>
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="currentColor">
                <path
                    d="M4.71429 19V21H10.7143V16C10.7143 14.8954 11.6097 14 12.7143 14V14C13.8189 14 14.7143 14.8954 14.7143 16V21H20.7143V7.25019L12.7143 3L4.71429 7.25019V15"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
            </svg>
        </SvgIcon>
    );
};
